<template>
  <el-dialog :title="'新增子账号'" :visible="true" :before-close="closeForm" :close-on-click-modal="false"
    :close-on-press-escape="false" width="30%">
    <el-form ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="子账号名" prop="subLoginAccount">
        <el-input v-model.trim="ruleForm.subLoginAccount"></el-input>
      </el-form-item>
      <el-form-item label="手机" prop="mobile">
        <el-input v-model.trim="ruleForm.mobile"></el-input>
      </el-form-item>
      <div class="align-center">
        <el-button type="primary" @click="submitForm()">确定</el-button>
        <el-button @click="closeForm()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
//import { mapGetters } from "vuex";
export default {
  props: ["agentid", "vendorid"],
  data () {
    return {
      ruleForm: {
        subLoginAccount: "",
        mobile: "",
      },
      userType: this.$getUserType()
    };
  },
  methods: {
    aaa () {
      console.log('agentid', this.agentid)
      console.log('vendorid', this.vendorid)
    },

    clearData(){
      this.ruleForm= {
        subLoginAccount: "",
        mobile: "",
      }
    },
    submitForm () {
      let saveModel = {
        agentid: this.agentid,
        vendorid: this.vendorid,
        accountType:2,
        subLoginAccount: this.ruleForm.subLoginAccount,
        mobile: this.ruleForm.mobile,
      };
      this.$axios(this.$urlMapping["子账号添加"], {
        data: saveModel
      }).then(result => {
        console.log(result)
        this.clearData()
        this.$emit("refresh");
      });
    },

    closeForm () {
      console.log('close')
      this.$emit("closeAddSubAccount");
    },
  },



  async mounted () {
    this.aaa()
    if (this.userType === "admin") {
      console.log('ccc')
    }
  }
};
</script>

<style lang="less" scoped></style>
